import PairAction from "./PairAction.js";
import PairingOpenAction from "./PairingOpenAction.js";
import SelectPairAssetAction from "./SelectPairAssetAction.js";
import ReselectAssetPairAction from "./ReselectAssetPairAction.js";
import SelectPairChildAction from "./SelectPairChildAction.js";
import SelectPairUnpairAction from "./SelectPairUnpairAction.js";
import SelectPairSummaryAction from "./SelectPairSummaryAction.js";
import SelectUnpairAction from "./SelectUnpairAction.js";
import SelectUnpairSummaryAction from "./SelectUnpairSummaryAction.js";
import UnpairAction from "./UnpairAction.js";
import ReselectChildPairAction from "./ReselectChildPairAction.js";
import CloseAction from "./CloseAction.js";
import PairAnotherAction from "./PairAnotherAction.js";
import UnpairAnotherAction from "./UnpairAnotherAction.js";
export default {
  install(molten) {
    molten.addPlugin('WizardAction', PairingOpenAction);
    molten.addPlugin('WizardAction', SelectPairAssetAction);
    molten.addPlugin('WizardAction', ReselectAssetPairAction);
    molten.addPlugin('WizardAction', ReselectChildPairAction);
    molten.addPlugin('WizardAction', SelectPairChildAction);
    molten.addPlugin('WizardAction', SelectUnpairAction);
    molten.addPlugin('WizardAction', SelectPairUnpairAction);
    molten.addPlugin('WizardAction', SelectPairSummaryAction);
    molten.addPlugin('WizardAction', PairAction);
    molten.addPlugin('WizardAction', SelectUnpairSummaryAction);
    molten.addPlugin('WizardAction', UnpairAction);
    molten.addPlugin('WizardAction', CloseAction);
    molten.addPlugin('WizardAction', PairAnotherAction);
    molten.addPlugin('WizardAction', UnpairAnotherAction);
  }
};